var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDrinkSoftCold = function SvgDrinkSoftCold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 13.2 21.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M.6 4.6h12m-12 12h12M3.1.6 1.064 3.044A2 2 0 0 0 .6 4.324v12.67a2 2 0 0 0 .336 1.11l1.07 1.605a2 2 0 0 0 1.664.891h5.86a2 2 0 0 0 1.664-.89l1.07-1.606a2 2 0 0 0 .336-1.11V4.324a2 2 0 0 0-.464-1.28L10.1.6m-7 0h-2m2 0h7m0 0h2m-3.5 10a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
  })));
};
export default SvgDrinkSoftCold;